import React from 'react';
import FilterTable from './filterTable';
import { jsonColumn } from './tableUtils';
import { OfflineLicenseColumnCaptions } from './tableColumnCaptions';

const OfflineLicenseHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: {type: 'datetime'},
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'previousValues',
    text: 'Previous values',
    sort: true,
    filter_: { type: 'text' }
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="offlineLicensesHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        previousValues: jsonColumn(histrec.previousValues, OfflineLicenseColumnCaptions)
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no offline license history records"
    />
  );
};

export default OfflineLicenseHistoryTable;



// WEBPACK FOOTER //
// ./src/components/offlineLicenseHistoryTable.js